import { useCallback, useMemo } from 'react';

import {
  GES_STATUS_FILTER_ID,
  getActiveGesStatuses,
} from '../lib/results-filters';
import { GesStatusStat } from '../lib/results-stats';

import { useFiltersStore } from '@data-access';

export { getActiveGesStatuses } from '../lib/results-filters';

export function useResultsQuickFilters() {
  const filters = useFiltersStore.use['results']().filters;
  const setFilterAndResetPage = useFiltersStore(
    (state) => state.setFilterAndResetPage,
  );
  const resetFilterAndResetPage = useFiltersStore(
    (state) => state.resetFilterAndResetPage,
  );

  const activeStatuses = useMemo(
    () => getActiveGesStatuses(filters),
    [filters],
  );

  const toggleGesStatus = useCallback(
    (status: GesStatusStat) => {
      const next = new Set(activeStatuses);
      if (next.has(status)) {
        next.delete(status);
      } else {
        next.add(status);
      }

      if (next.size === 0) {
        resetFilterAndResetPage('results', GES_STATUS_FILTER_ID);
      } else if (next.size === 1) {
        setFilterAndResetPage('results', GES_STATUS_FILTER_ID, [...next][0]);
      } else {
        setFilterAndResetPage('results', GES_STATUS_FILTER_ID, [...next]);
      }
    },
    [activeStatuses, resetFilterAndResetPage, setFilterAndResetPage],
  );

  return {
    activeStatuses,
    toggleGesStatus,
  };
}
